export class FAQs {
  static selector = "[data-component=faqs]"

  constructor(el) {
    this.root = el

    this.setup()
  }

  onToggle = ev => {
    ev.preventDefault()
    const question = ev.target.closest(".faqs__question")
    question.toggleAttribute("data-open")
  }

  setup() {
    for (const a of this.root.querySelectorAll("[data-action=faq-toggle]")) {
      a.addEventListener("click", this.onToggle)
    }
  }
}
